import axios from 'axios';
import stream from './stream';

export default {
  async checkMixerStatus() {
    return await axios
      .get(`https://mixer.com/api/v1/channels/${stream.mixer.name}`)
      .then(response => {
        if (response.status === 200) {
          return response.data;
        }
        return response;
      })
      .catch(e => {
        console.log('Mixer streamer not found!', e);
        return false;
      });
  },

  async checkTwitchStatus() {
    axios.defaults.headers.common['Client-ID'] = stream.twitch.client_id;
    return await axios
      .get(
        `https://api.twitch.tv/helix/streams/?user_id=${stream.twitch.user_id}`
      )
      .then(response => {
        if (response.status === 200) {
          return response.data;
        }
        return response;
      })
      .catch(e => {
        console.log('Twitch streamer not found!', e);
        return false;
      });
  }
};
